export default [
    {
        key: "forwardhead",
        name: "انحناء الرأس إلى الأمام",
        definition: {
            name: "تعريف",
            list: ["انحناء الرأس إلى الأمام يعني أن الرأس في وضع مائل إلى الأمام بشكل غير طبيعي بالنسبة للجذع عندما يكون الجسم البشري في وضع الوقوف أو الجلوس الطبيعي. وهو شائع بين الطلاب والموظفين في المكاتب الذين يجلسون لفترات طويلة."]
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1، العمل منحنيا لفترة طويلة. عندما يعمل المرء أمام الكمبيوتر لفترة طويلة، تميل الرأس إلى الأمام عادة.",
                "2. التعودة إلى خفض الرأس للنظر إلى الهاتف المحمول. النظر إلى الهاتف المحمول برأس منخفض، أي ما يسمى ‘قبيلة المنحنيين الرأس’، هو أيضا أحد الأسباب الرئيسية التي تؤدي إلى انحناء الرأس إلى الأمام.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. الدوار والصداع: انحناء الرأس إلى الأمام قد يؤثر على الدورة الدموية في الرأس. بسبب ضعف الدورة الدموية، يحدث نقص في الأكسجين في الرأس، مما يسبب الدوار والصداع.",
                "2. آلام الرقبة: بسبب وضع غير طبيعي للرأس، تحدث شذوذات في الأنسجة الرخوة والعظام في الرقبة، مما يزيد من خطر الإصابة بمرض في الرقبة.",
                "3. أمراض القلب والأوعية الدموية والدماغية: قد تؤثر الوضعية غير الطبيعية للرأس على الدورة الدموية في الرأس وتضر بصحة القلب والأوعية الدموية والدماغية.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "انحناء الجانبي للرأس",
        definition: {
            name: "تعريف",
            list: ["انحناء الجانبي للرأس يعني الوضع غير الطبيعي عندما تميل الرأس بشكل مفرط إلى جانب واحد عندما يكون الجسم البشري في وضع الوقوف أو الجلوس الطبيعي. السبب الرئيسي هو عدم التوازن في قوة العضلات في منطقة الرقبة والكتف من الجانبين، والذي يحدث عادة بسبب وضعيات خاطئة متعود عليها."]
        },
        triggerreason: {
            name: "أسباب",
            list: [
                "1. العادة في استخدام عضلات الرقبة والكتف من جهة واحدة: عند الجلوس أو الاستلقاء، غالبًا ما يميل الرقبة إلى جانب واحد فقط، مما يسبب عدم توازن في قوة عضلات الرقبة والكتف من الجانبين.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. التهاب المفاصل المزمن: يمكن أن يؤدي انحناء الرأس الجانبي لفترة طويلة إلى التهاب المفاصل المزمن في الأربطة الخلفية للرقبة والأربطة العضلية.",
                "2. آلام الرقبة: بسبب وضع غير طبيعي للرأس، تحدث شذوذات في الأنسجة الرخوة والعظام في الرقبة، مما يزيد من خطر الإصابة بمرض في الرقبة.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "كتفان غير متساوين",
        definition: {
            name: "تعريف",
            list: ["كتفان غير متساوين يشير إلى الوضع الذي يكون فيه الكتفان على الجانبين مختلفين في الارتفاع الرأسي عندما يكون الجسم البشري في حالة استرخاء طبيعية. عادة ما يصاحب الكتفان غير المتساويين شذوذات في وضع العمود الفقري."]
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. ضغط مفرط على جانب واحد: على سبيل المثال، حمل حقيبة ظهر أو أشياء ثقيلة على جانب واحد لفترة طويلة.",
                "2. الوضع الخاطئ لفترة طويلة: يحدث بسبب العادات السيئة مثل ск-crossing legs والجلوس لفترة طويلة، أو الانحناء على الطاولة عند العمل منحنيا.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. ألم في الظهر: (كتفان غير متساوين) قد يسببان إزاحة الحوض، مما يجعل قوة العضلات في جانبي الخصر غير متوازنة ويسبب ألما في الظهر.",
                "2. نتوء العظم: الكتفان غير المتساويين يسببان قوة غير طبيعية على العمود الفقري العنقي، ويمكن في النهاية أن يؤدي إلى تدهور منطقة العمود الفقري العنقي ويكون من السهل تشكيل نتوءات العظام.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "كتفان مستديران",
        definition: {
            name: "تعريف",
            list: ["الكتفان المدوران يشير إلى الحالة التي يظهر فيها الكتفان مقوسين إلى الأمام وإلى الداخل عند النظر إليهما من الجانب. غالبًا ما يصاحبها сутول. شائع بين الطلاب والعاملين في المكاتب."],
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. وضعية سيئة عادة: مثل الانحناء والجلوس مع وجود بروز في الظهر، الاستلقاء على الجانب بشكل غير منتظم إلخ.",
                "2. عدم توازن العضلي في الصدر والظهر: العضلات الصدرية ضعيفة نسبيًا مقارنة بالعضلات الظهرية.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. زيادة العبء على القلب: الكتفان المدوران بشكل مفرط سيجعلان الحجاب الحاجز في حالة توتر، مما يسبب ضغطًا على الشريان الأبهري والوريد الأجوف الكبير، ويزيد من عبء عمل القلب.",
                "2. الضغط على الأعصاب: التوتر العضلي حول الكتفين والرقبة يمكن أن يضغط على الأعصاب العنقية في الحالات الشديدة، مسبباً صداعاً وخدراً في الذراع.",
            ],
        }
    },
    {
        name: "انحناء العمود الفقري الجانبي",
        key: "scoliosis",
        definition: {
            name: "تعريف",
            list: ["تحدث شذوذات في وضع العمود الفقري. من خلال الفحوصات التصويرية، يمكن اكتشاف حالات غير مستقيمة للعمود الفقري مثل انحناء العمود الفقري الجانبي. الشذوذات يمكن تقسيمها إلى خلقية ومكتسبة. الشذوذات المكتسبة مرتبطة بأخطاء العادات الوضعية."],
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. ضغط أحادي مفرط: على سبيل المثال، حمل حقيبة ظهر أو أشياء ثقيلة من جانب واحد لفترة طويلة.",
                "2. الوضع الخاطئ لفترة طويلة: يحدث بسبب العادات السيئة مثل ск-crossing legs والجلوس لفترة طويلة، أو الانحناء على الطاولة عند العمل منحنيا.",
                "3. أسباب خلقية: انحناء العمود الفقري الجانبي الناجم عن عوامل خلقية.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. بروز القرص الغضروفي في منطقة الفقرات القطنية.",
                "2. ألم الظهر: قد يسبب تحرك الحوض، مما يجعل قوة العضلات على جانبي الخصر غير متوازنة ويسبب ألم الظهر.",
                "3. ساقان ذات طولين مختلفين.",
            ],
        }
    },
    {
        name: "ميلان جانبي الحوض",
        key: "unevenhip",
        definition: {
            name: "تعريف",
            list: ["ميلان جانبي الحوض يشير إلى الحالة التي يكون فيها ارتفاع الوركين من الجانبين مختلفًا إلى حد كبير، ويظهر الحوض في حالة مائلة. غالبًا ما يصاحب ذلك شذوذات في وضع العمود الفقري وكتفين غير متساوين."],
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. الوضع الخاطئ لفترة طويلة: يحدث بسبب العادات السيئة مثل تقاطع الساقين والجلوس لفترة طويلة، أو الانحناء على الطاولة عند العمل منحنيا.",
                "2. ساقان ذات طولين مختلفين خلقية: ميلان جانبي الحوض بسبب ساقان ذات طولين مختلفين خلقية.",
                "3. عدم توازن وضعية الأطراف السفلية من الجانبين: على سبيل المثال، أحد الأقدام لديه плоск-foot بينما الآخر لا يوجد، أو الدرجة مختلفة؛ كلا الجانبين لديه فرط تمتد في الركبة، لكن الدرجة مختلفة.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. بروز القرص الغضروفي في منطقة الفقرات القطنية.",
                "2. ألم مزمن: ميلان جانبي الحوض قد يسبب ألم في الساقين والخصر، وكذلك في الرقبة والكتفين.",
                "3. ساقان ذات طولين مختلفين.",
            ],
        }
    },
    {
        name: "ركبتان على شكل حرف O",
        key: "oleg",
        definition: {
            name: "تعريف",
            list: ["عندما يقف الإنسان بانتظام طبيعي والقدمين معا، يمكن الكاحلين الداخليين التلاصق، لكن الداخل من الركب لا يمكن التلاصق ويمكن أن يكون هناك فجوة كبيرة حتى. بين الساقين يظهر شكل \"O\". هذا النوع من شكل الساق مرتبط بعادات الموقف اليومية. ظهور ساقين على شكل \"O\" عند الأطفال قد يكون مرتبطا بمرض الكساح أيضا."],
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. العادات السيئة للوضع مثل: ميلان الحوض للخلف، والاتجاه نحو إدخال القدم.",
                "2. عدم توازن في قوة العضلات مثل: عضلات الدوران الخارجية للحوض ضيقة للغاية.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. إصابة meniscus الداخلي: الأرجل في شكل حرف O تسبب تغييرًا في خط قوة الأطراف السفلية. الفضاء الداخلي للركبة يتعرض لضغط أكبر من الحمل الطبيعي. قد يسبب إصابة meniscus الداخلي للركبة.",
                "2. التهاب المفاصل: الحالات الشديدة (الأرجل في شكل حرف O) قد تتطور في النهاية إلى التهاب المفاصل العظمي في مفصل الركبة وتنكس المفصل في الفضاء المفصلي الجانبي. في الحالات الشديدة، قد يكون من الضروريجراء عملية استبدال المفصل الاصطناعي.",
            ],
        }
    },
    {
        name: "أرجل في شكل حرف X",
        key: "xleg",
        definition: {
            name: "تعريف",
            list: "عندما يقف الإنسان في وضع طبيعي والقدمين ملتصقتين، يمكن أن تكون الركب الداخلية قريبة من بعضها البعض، لكن الجزء الداخلي من الكاحلين لا يمكن أن يكون قريباً وقد يكون هناك فجوة كبيرة حتى. الشكل بين الساقين مثل الحرف \"X\". هذا النوع من شكل الساقين مرتبط بعادات الموقف اليومية واختلال التوازن العضلي.",
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. العادات السيئة في الوضع مثل: ميل الحوض إلى الأمام، الميل إلى إخراج القدم.",
                "2. عدم توازن القوة العضلية مثل: عضلات دوران الورك الداخلية ضيقة جدا.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. إصابة meniscus الجانبي: الأرجل في شكل حرف X تسبب تغييرًا في خط قوة الأطراف السفلية. الفضاء الجانبي للركبة يتعرض لضغط أكبر من الحمل الطبيعي. قد يسبب إصابة meniscus الجانبي للركبة.",
                "2. التهاب المفاصل: الحالات الشديدة (الأرجل في شكل حرف X) قد تتطور في النهاية إلى التهاب المفاصل العظمي في مفصل الركبة وتنكس المفصل في الفضاء المفصلي الجانبي. في الحالات الشديدة، قد يكون من الضروريجراء عملية استبدال المفصل الاصطناعي.",
            ],
        }
    },
    {
        name: "زيادة الانثناء الخلفية للركبة",
        key: "kneehyperextension",
        definition: {
            name: "تعريف",
            list: ["زيادة الانثناء الخلفية للركبة، المعروفة أيضًا باسم 'القوس العكسي للركبة'. من الجانب البشري، يمكن ملاحظة أن الساق تنحني إلى الخلف، والركبة مقعرة إلى الداخل، والكاحل يمتد إلى الأمام بشكل مفرط مقارنة بالفخذ. هذا النوع من الموقف شائع بين راقصات الباليه وأولئك الذين لديهم ضعف في العضلات الفخذية."],
        },
        triggerreason: {
            name: "الأسباب",
            list: [
                "1. وضعية خاطئة لتطبيق القوة: عند الوقوف، يتركز الوزن الرئيسي على مقدمة القدم.",
                "2. التوتر في الوتر الأخمصي: يمكن أن يكون سببه ارتداء الكعب العالي لفترة طويلة.",
                "3. ضعف العضلات حول الركبة. عدم كفاية القوة العضلية في الجزء الأمامي والخلفي للفخذ.",
            ]
        },
        danger: {
            name: "أضرار",
            list: [
                "1. تشوه في مفصل الركبة: الإفراط في التمدد الخلفي للركبة لفترة طويلة يمكن أن يؤدي إلى زيادة كبيرة في معدل حدوث التآكل العظمي المفصلي ويسبب تآكلًا مفرطًا في مفصل الركبة، مما يؤدي إلى تشوه المفصل.",
                "2. ضرر في التوازن العام: هناك علاقة كبيرة بين المفاصل الثلاثة للورك والركبة والكاحل من حيث الموقع والوظيفة. تغيير موضع الركبة سيؤثر على موضع الكاحل أسفلها وموضع الورك والحوض أعلى منها، مما يضر تدريجيًا بالتوازن العام للجسم. على المدى الطويل، يمكن أن يسبب هذا أنواعًا مختلفة من الألم.",
            ],
        }
    },
]